import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-57935622"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "courseList" };
const _hoisted_2 = ["onClick"];
const _hoisted_3 = { class: "imgBox" };
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 0,
    class: "type font-24"
};
const _hoisted_6 = {
    key: 1,
    class: "newIcon"
};
const _hoisted_7 = { class: "msgBox font-24" };
const _hoisted_8 = { class: "info flex-1 border-box" };
const _hoisted_9 = { class: "title text-ell2 font-32" };
const _hoisted_10 = {
    key: 0,
    class: "teacher text-overflow font-28"
};
const _hoisted_11 = { class: "expert gray-6" };
const _hoisted_12 = { class: "hospital gray-6" };
const _hoisted_13 = { class: "expert gray-6" };
const _hoisted_14 = { class: "hospital gray-6" };
const _hoisted_15 = { class: "expert gray-6" };
const _hoisted_16 = { class: "hospital gray-6" };
const _hoisted_17 = {
    key: 1,
    class: "studyInfo gray-6 font-24"
};
const _hoisted_18 = {
    key: 0,
    class: "date text-overflow"
};
const _hoisted_19 = {
    key: 0,
    class: "date text-overflow"
};
const _hoisted_20 = {
    key: 1,
    class: "date text-overflow"
};
const _hoisted_21 = {
    key: 2,
    class: "date text-overflow"
};
const _hoisted_22 = {
    key: 1,
    class: "date text-overflow"
};
const _hoisted_23 = {
    key: 2,
    class: "time"
};
const _hoisted_24 = { key: 0 };
const _hoisted_25 = { key: 1 };
const _hoisted_26 = { class: "process themeColor font-24 m-l8" };
const _hoisted_27 = /*#__PURE__*/ _createTextVNode("未学习");
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { clas: "gray-9" }, "已学", -1));
const _hoisted_29 = {
    key: 0,
    class: "date text-overflow"
};
const _hoisted_30 = { class: "date text-overflow" };
const _hoisted_31 = { class: "process themeColor font-24 m-l8" };
const _hoisted_32 = { class: "time" };
const _hoisted_33 = { class: "process themeColor font-24 m-l8" };
const _hoisted_34 = {
    key: 3,
    class: "num gray-6 font-24"
};
import { getCurrentInstance } from 'vue';
import { appPort, jumpModuleApp, goToStudy, callAppView, iOSPort, getUserId } from '@/widget';
import { hostPath } from '@/public/utils/basePath';
import { useRouter, useRoute } from 'vue-router';
import { useWxLaunchApp } from '@/hooks/appPage';
import { getCoursePermission } from '@/api/video';
export default /*#__PURE__*/ _defineComponent({
    props: {
        list: {
            type: Array,
            default: () => []
        },
        process: {
            // 是否是练中的列表数据，显示学习进度
            default: false,
            type: Boolean
        },
        recommend: {
            // 是否是推荐的列表数据
            default: false,
            type: Boolean
        },
        isLiveOpen: {
            // 是否是直播间打开
            default: false,
            type: Boolean
        }
    },
    emits: ['toRecommend'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { proxy: { $showLoading, $hideLoading } } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const routeName = String(route.name);
        const fixedStatus = (item) => {
            if ((item.targetType == 'album' && item.detailType !== 'online') ||
                (item.moduleType != 'onlineOperation' &&
                    item.moduleType != 'omoOperation' &&
                    props.recommend) ||
                (item.courseType == 'album' && props.process)) {
                return true;
            }
            return false;
        };
        let isApp = appPort();
        const userId = getUserId();
        const toLearn = (courseId, courseType) => {
            if (isApp) {
                goToStudy(courseType, courseId);
            }
            else {
                location.assign(`${hostPath}/course/${courseType}/${courseId}`);
            }
        };
        // 判断用户是否购买课程
        const judgeCourse = (courseId, type, bl) => {
            return new Promise(reslove => {
                $showLoading();
                if (!/^(courseTypeList|courseList)$/.test(routeName)) {
                    $hideLoading();
                    reslove(false);
                }
                getCoursePermission(courseId, {
                    userId,
                    isSchedule: bl,
                    courseType: type
                }).then((res) => {
                    $hideLoading();
                    if (res.code == 200) {
                        let { permission, courseId, courseType } = res.data;
                        if (permission) {
                            // 购买了进入学习页
                            toLearn(courseId, courseType);
                        }
                        reslove(permission);
                    }
                    else {
                        reslove(false);
                    }
                });
            });
        };
        // 进入详情
        const toDetail = (item) => {
            if (props.recommend) {
                recommendDetail(item); // 推荐课程列表走新的跳转方法
                return;
            }
            // if (showLaunch(item)) {
            //   // 判断是否使用 微信 wx-open-launch-app
            //   return
            // }
            let { targetType, moduleType, id, detailType, tcId } = item;
            let banqi = targetType == 'album' && detailType == 'online';
            if (isApp) {
                if (moduleType == 'operation' && tcId) {
                    // 老训练营
                    jumpModuleApp({
                        typeId: 'operation_detail',
                        dataId: tcId
                    });
                    return;
                }
                if (moduleType == 'open') {
                    // 公开课直接进入学习页
                    goToStudy('album', id);
                    return;
                }
                if (props.process) {
                    // app 练 中展示学习进度，直接进入学习页
                    jumpModuleApp({
                        typeId: 'study_play_detail',
                        type: item.courseType,
                        dataId: item.id
                    });
                    return;
                }
                if (targetType == 'album') {
                    // 专辑 detailType == online 是班期课
                    let type = detailType == 'online' ? 'meeting' : 'album';
                    judgeCourse(id, targetType, banqi).then(res => {
                        if (!res) {
                            jumpModuleApp({
                                url: `${hostPath}/learn/courseguide/${type}/${id}`,
                                typeId: 'h5'
                            });
                        }
                    });
                }
                else if (targetType == 'meeting') {
                    // 训练营
                    if (moduleType == 'meeting') {
                        // 学习班
                        jumpModuleApp({
                            dataId: id,
                            typeId: 'meeting_detail'
                        });
                    }
                    else {
                        // 共学营、omo（老训练营走上面的逻辑）
                        judgeCourse(id, targetType, banqi).then(res => {
                            if (!res) {
                                jumpModuleApp({
                                    url: `${hostPath}/learn/courseguide/train/${id}`,
                                    typeId: 'h5'
                                });
                            }
                        });
                    }
                }
            }
            else {
                // h5 中
                if (targetType == 'album') {
                    if (props.process) {
                        if (moduleType == 'operation' && tcId) {
                            // 老训练营
                            callAppView({
                                typeId: 'operation_detail',
                                dataId: tcId
                            });
                            return;
                        }
                        let t = item.courseType;
                        goToStudy(t, item.id);
                        return;
                    }
                    if (targetType == 'album' && detailType == 'online') {
                        // 班期课程
                        judgeCourse(id, targetType, banqi).then(res => {
                            if (!res) {
                                router.push(`/courseguide/meeting/${id}`);
                            }
                        });
                        return;
                    }
                    if (/(open|knowledge)/.test(moduleType)) {
                        //  公开课 知识点
                        // location.assign(`${hostPath}/open/detail?id=${id}`)
                        // goToStudy('album', item.id)
                        location.assign(`${hostPath}/course/album/${item.id}`);
                        return;
                    }
                    judgeCourse(id, targetType, banqi).then(res => {
                        if (!res) {
                            router.push(`/courseguide/album/${id}`);
                        }
                    });
                }
                else {
                    if (moduleType == 'operation' && tcId) {
                        // tcId 老训练营
                        location.assign(`${hostPath}/training/detail?id=${tcId}`);
                    }
                    else if (/(onlineOperation|omoOperation)/.test(moduleType) ||
                        detailType == 'omo') {
                        judgeCourse(id, targetType, banqi).then(res => {
                            if (!res) {
                                // omo 共学营
                                router.push({
                                    name: 'courseGuidePage',
                                    params: {
                                        type: 'train',
                                        id: id
                                    }
                                });
                            }
                        });
                    }
                }
            }
        };
        // 课程推荐进入详情页
        const recommendDetail = item => {
            let { targetType, moduleType, id, detailType, tcId, courseType } = item;
            if (moduleType == 'open') {
                emits('toRecommend', { recommendType: 'open' });
            }
            else if (moduleType == 'omoOperation' || moduleType == 'operation') {
                emits('toRecommend', { recommendType: 'OMO' });
            }
            else {
                emits('toRecommend', { recommendType: 'masterCourse' });
            }
            if (isApp) {
                if (moduleType == 'operation' && tcId) {
                    // 老训练营
                    jumpModuleApp({
                        typeId: 'operation_detail',
                        dataId: tcId
                    });
                    return;
                }
                if (moduleType == 'open') {
                    // 公开课直接进入学习页
                    goToStudy('album', id);
                    return;
                }
                if (courseType == 'album') {
                    // 专辑 detailType == online 是班期课
                    let type = detailType == 'online' ? 'meeting' : 'album';
                    jumpModuleApp({
                        url: `${hostPath}/learn/courseguide/${type}/${id}`,
                        typeId: 'h5'
                    });
                }
                else if (courseType == 'meeting') {
                    // 训练营
                    if (moduleType == 'meeting') {
                        // 学习班
                        jumpModuleApp({
                            dataId: id,
                            typeId: 'meeting_detail'
                        });
                    }
                    else {
                        // 共学营、omo（老训练营走上面的逻辑）
                        location.replace(`${hostPath}/learn/courseguide/train/${id}${props.isLiveOpen ? '?is_live_open=1' : ''}`);
                    }
                }
            }
            else {
                // h5 中
                if (moduleType == 'operation' && tcId) {
                    // 老训练营
                    callAppView({
                        typeId: 'operation_detail',
                        dataId: tcId
                    });
                    return;
                }
                if (/(omoOperation|onlineOperation)/.test(moduleType)) {
                    location.assign(`/learn/courseguide/train/${id}`);
                    return;
                }
                if (moduleType == 'open') {
                    // 公开课直接进入学习页
                    goToStudy('album', id);
                    return;
                }
                location.assign(`/learn/courseguide/album/${id}`);
            }
        };
        // 微信
        const extinfo = (item) => {
            let { albumId, moduleType, tcId, id } = item;
            if (moduleType == 'operation' && tcId) {
                // 老训练营
                return {
                    typeId: 'operation_detail',
                    dataId: tcId
                };
            }
            if (props.process) {
                // app 练 中展示学习进度，直接进入学习页
                return {
                    typeId: 'study_play_detail',
                    type: item.courseType,
                    dataId: item.id
                };
            }
            if (moduleType == 'open') {
                // 公开课直接进入学习页
                return {
                    typeId: 'study_play_detail',
                    type: 'album',
                    dataId: albumId || id
                };
            }
        };
        const { isWechat, handleErrorFn, handleLaunchFn, launchReady, btnStyle } = useWxLaunchApp();
        // 是否显示按钮 公开课、练 微信中 Android 设备
        const showLaunch = (item) => {
            if ((item.moduleType == 'open' || props.process) &&
                !iOSPort() &&
                isWechat.value) {
                return true;
            }
            return false;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, key) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["flex", { 'p-b58': fixedStatus(item) && item.openStatusText }]),
                        key: item.id,
                        onClick: _withModifiers(($event) => (toDetail(item)), ["stop"])
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("img", {
                                src: (item.websiteImage || item.image)?.replace('w_500', 'w_378'),
                                alt: ""
                            }, null, 8, _hoisted_4),
                            (item.typeName || item.courseTypeName || item.detailTypeName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item.typeName || item.courseTypeName || item.detailTypeName), 1))
                                : _createCommentVNode("", true),
                            (item.courseNewOnlineStatus)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.courseNewOnlineStatusText), 1)
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(item.title || item.meetingName), 1),
                            (item.expertName || item.expertList?.length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    (item.expertName)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(item.expertName) + " ", 1),
                                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.expertHospitalName), 1)
                                        ], 64))
                                        : (item.expertList)
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(item.expertList, (expert) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString(expert.expertName) + " ", 1),
                                                    _createElementVNode("span", _hoisted_14, _toDisplayString(expert.expertHospitalName), 1)
                                                ], 64));
                                            }), 256))
                                            : (item.expertNameList?.length)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.expertNameList, (n) => {
                                                        return (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(n), 1));
                                                    }), 256)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.hospitalNameList, (n) => {
                                                        return (_openBlock(), _createElementBlock("span", _hoisted_16, "  " + _toDisplayString(n), 1));
                                                    }), 256))
                                                ], 64))
                                                : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            (!__props.process)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    (/^(meeting|operation|onlineOperation|omoOperation)/.test(item.moduleType))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            (item.onlineTime)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    (item.isComing !== '0')
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(item.onlineTime +
                                                            ' | ' +
                                                            item.meetingProvince +
                                                            item.location.replace(/地点：/, ' ')), 1))
                                                        : _createCommentVNode("", true)
                                                ], 64))
                                                : (item.detailType === 'online')
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                        (item.isComing !== '0')
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.time) + " " + _toDisplayString(item.location), 1))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(item.time), 1))
                                                    ], 64))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.time) + " " + _toDisplayString(item.location), 1))
                                        ], 64))
                                        : (item.detailType == 'online' && item.targetType == 'album')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(item.time), 1))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                (item.lengthCount)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.lengthCount) + "分钟 ", 1))
                                                    : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.lengthCountText?.replace(/(时长：)/g, '')), 1)),
                                                _withDirectives(_createElementVNode("span", { class: "m-l20" }, _toDisplayString(item.courseOnlineTime?.replace(/上架/g, '')) + "上架", 513), [
                                                    [_vShow, item.courseOnlineTime]
                                                ])
                                            ]))
                                ]))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass(["studyInfo gray-6 font-24 processBottom", {
                                            omoItem: /^(operation|omoOperation)/.test(item.moduleType)
                                        }])
                                }, [
                                    (/^(operation|omoOperation)/.test(item.moduleType))
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createElementVNode("div", _hoisted_26, [
                                                (item.studyStatus == 0)
                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                        _hoisted_27
                                                    ], 64))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("template", null, [
                                                    _hoisted_28,
                                                    _createTextVNode(_toDisplayString(item.finish + '%'), 1)
                                                ])
                                            ]),
                                            (item.unlockType && item.unlockType != 3)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(item.time) + " " + _toDisplayString(item.location), 1))
                                                : _createCommentVNode("", true)
                                        ], 64))
                                        : (/^(meeting|onlineOperation)/.test(item.moduleType))
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createElementVNode("div", _hoisted_30, _toDisplayString(item.time) + " " + _toDisplayString(item.location), 1),
                                                _createElementVNode("div", _hoisted_31, _toDisplayString(item.studyStatus == 0 ? '未学习' : '已学 ' + item.finish + '%'), 1)
                                            ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                _createElementVNode("div", _hoisted_32, _toDisplayString(item.lengthCount) + "分钟", 1),
                                                _createElementVNode("div", _hoisted_33, _toDisplayString(item.studyStatus == 0 ? '未学习' : '已学 ' + item.finish + '%'), 1)
                                            ], 64))
                                ], 2)),
                            (item.playedCount != '0' && item.playedCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.playedCount.replace(/(人学习)/g, '')) + "人学习 ", 1))
                                : _createCommentVNode("", true),
                            (!fixedStatus(item) && item.openStatusText)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 4,
                                    class: _normalizeClass(["openStatus", { grayColor: item.openStatus != '1' }])
                                }, _toDisplayString(item.openStatusText), 3))
                                : _createCommentVNode("", true)
                        ])
                    ], 10, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
